<ul class="list-group">
  <ng-container *ngFor="let item of listGroupItems; last as isLast">
    <li
      class="d-flex align-items-center justify-content-between cursor-pointer"
      [ngClass]="{ 'pb-3': !item.toggled && !isLast, 'pb-2': item.toggled, 'pt-3 bold': !condensed }"
      (click)="item.toggled = !item.toggled"
    >
      {{ item.header }}
      <app-rotating-caret [rotateCaret]="item.toggled" color="#009688" fontSize=".8rem"></app-rotating-caret>
    </li>

    <!-- Dropdown Part -->
    <ul class="list-group dropdown-group" [hidden]="!item.toggled" [@fadeInOut]>
      <p class="paragraph-text text-grey mt-2" *ngIf="item.body">{{ item.body }}</p>
      <li
        class="d-flex align-items-center justify-content-between font-weight-light"
        [class.py-2]="!condensed"
        [class.pb-3]="isLastItem"
        *ngFor="let dropdownItem of item.dropdownItems; last as isLastItem"
      >
        <span class="paragraph-text mw-50" [innerHtml]="dropdownItem.leftText"></span>
        <span class="paragraph-text text-grey mw-50 text-right" [innerHtml]="dropdownItem.rightText"></span>
      </li>
    </ul>
    <div [class.bb-light]="!isLast"></div>
  </ng-container>
</ul>

<!-- <div class="text-green mt-2">
  See All
</div> -->
